var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_746_28608)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C17.0752 0 22 4.92479 22 11C22 17.0752 17.0752 22 11 22C4.92479 22 0 17.0752 0 11C0 4.92479 4.92479 0 11 0ZM6.13342 11.2926C6.281 10.4369 7.25771 9.9605 8.0284 10.4241C8.09829 10.4658 8.16498 10.5153 8.22708 10.5721L8.23304 10.5779C8.57885 10.9093 8.96637 11.2541 9.35046 11.5961L9.68 11.8919L13.5903 7.79029C13.8238 7.54577 13.9945 7.38765 14.3449 7.30881C15.5446 7.04413 16.3882 8.51056 15.538 9.40683L10.6645 14.5214C10.2055 15.0111 9.38506 15.0558 8.89167 14.5881C8.60888 14.3254 8.30133 14.0582 7.99035 13.7885C7.45181 13.3205 6.9025 12.8432 6.45471 12.3706C6.1859 12.1021 6.06994 11.6623 6.13342 11.2926Z",
    fill: "#6BBE66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_746_28608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectGreen);
export default __webpack_public_path__ + "static/media/CorrectGreen.82694a24132bc2a71951ff3aa44047ae.svg";
export { ForwardRef as ReactComponent };